import { Capacitor, registerPlugin } from '@capacitor/core';
import { getAppOrigin } from 'utils/appOrigin';

const WidgetBridgeNative = Capacitor.isNativePlatform()
  ? registerPlugin('WidgetBridge')
  : null;

export const refreshWidgetTimelines = async (clearCache = true) => {
  if (!WidgetBridgeNative) return;
  try {
    await WidgetBridgeNative.refreshTimelines({ clearCache });
  } catch (err) {
    console.error('Failed to refresh widget timelines:', err);
  }
};

export const setWidgetSession = async (userId, clubId) => {
  if (!WidgetBridgeNative || !userId || !clubId) return;
  try {
    await WidgetBridgeNative.setSession({
      userId: String(userId),
      clubId: String(clubId),
      apiBaseUrl: `${getAppOrigin()}/api`,
    });
  } catch (err) {
    console.error('Failed to sync widget session:', err);
  }
};

export const clearWidgetSession = async () => {
  if (!WidgetBridgeNative) return;
  try {
    await WidgetBridgeNative.clearSession();
  } catch (err) {
    console.error('Failed to clear widget session:', err);
  }
};
